import { render } from "./CardCharts.vue?vue&type=template&id=45052cd8"
import script from "./CardCharts.vue?vue&type=script&lang=js"
export * from "./CardCharts.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__